import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUluleComponent } from './simple-icons-ulule.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUluleComponent ],
    exports:      [ SimpleIconsUluleComponent ],
    bootstrap:    []
})
export class SimpleIconsUluleModule {}
